import React, { Component } from 'react';
import * as CCAction from '../actions/CycleCountAction';
import CycleCountStore from '../stores/CycleCountStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import { withTranslation, Trans } from 'react-i18next'
import SDIConstants from '../SDIConstants';
import swal from 'sweetalert';
import * as MenuAction from '../actions/MenuAction';
const style = {
    margintop: '9%',
}
let currentPagePath;
class CycleCount extends Component {
    constructor(props) {
        super(props);
        //this.LoadSearchResults = this.LoadSearchResults.bind(this);
        this.CCPageLoadData = this.CCPageLoadData.bind(this);
        this.CCPageLoadDataResponse = this.CCPageLoadDataResponse.bind(this);
        this.state = {
            PageGridArr: [],
            ImageAr: [],
            CountedImageAr: [],
            totalCount: "0",
            itemCount: 10,
            pageCount: 0,
            pageNo: 1,
            LineItemId: "",
            LineStoreArea: "",
            LineStorlev1: "",
            LineStorlev2: "",
            LineStorlev3: "",
            LineStorlev4: "",
            LineItemQty: "",
            LineSysbaseqty: "",
            firsttimeclick: 0,
            firstcount: 0,
            CountedPageGridArr: [],
            CountedtotalCount: "0",
            CounteditemCount: 10,
            CountedpageCount: 0,
            CountedpageNo: 1,
            PendingOrCounted: "0",
            qtyvalue: "",
            firsttimecheck1: [],
            sucpopItem: "", isFavorited: false,
            openAccordionIndex: null,
        }
    }
    componentDidMount() {
        //this.LoadSearchResults()
        //document.getElementById("Counted-tab").   
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        /*[15/12/23, PC_CPW_95_02, Vishwa S]*/
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (cribID.trim() == "" || cribID == null || cribID == undefined) {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            CCAction.getCurrentFavPage(getFavPageBO);
            this.CCPageLoadData("1");
            CycleCountStore.on('ccpageload', this.CCPageLoadDataResponse);
            CycleCountStore.on('UpdateQtyRes', this.UpdateQuantityResponse);
            CycleCountStore.on('Countedpageload', this.CountedPageLoadDataResponse);
            CycleCountStore.on('favpage', this.loadFavPageResponse); // Check this
            CycleCountStore.on('updateFavPage', this.updateFavPageResponse);
        }
    }
    componentWillUnmount() {
        CycleCountStore.removeListener('ccpageload', this.CCPageLoadDataResponse);
        CycleCountStore.removeListener('UpdateQtyRes', this.UpdateQuantityResponse);
        CycleCountStore.removeListener('Countedpageload', this.CountedPageLoadDataResponse);
        CycleCountStore.removeListener('favpage', this.loadFavPageResponse);
        CycleCountStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }
    CCPageLoadData = (pageno) => {

        //$('#myTabContent').addClass('show');
        //$('#mycountedTabContent').addClass('hide');
        let values = this.state.firsttimecheck1;
        values.forEach((val) => {
            values.splice(val);
        })
        this.setState({ PendingOrCounted: "0", firsttimecheck1: values })
        let CCPageLoadBO = {
            EmployeeID: CookieService.getLocalStorageValues("Session_UserID"),
            PageNo: pageno,
            ItemCount: this.state.itemCount,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"), /*[12/10/23, PC_CPW_119_01, Vishwa S]*/
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCAction.CCPageLoad(CCPageLoadBO);
    }
    CCPageLoadDataResponse = () => {


        let cyclecountResponse = JSON.parse(CycleCountStore.PageLoadData);
        let ccaray = cyclecountResponse.Table;
        let ImgArray = cyclecountResponse.ImgTable;
        //cyclecountResponse.Table[0].TOTAL_COUNT > 0 ? cyclecountResponse.Table[0].TOTAL_COUNT : 0,
        if (ccaray != undefined) {
            if (ccaray.length > 0) {
                let tc = cyclecountResponse.Table[0].TOTAL_COUNT;
                let ImageResponse;
                cyclecountResponse = cyclecountResponse.Table;
                cyclecountResponse.forEach((value, index) => {
                    value.EnteredQty = "";
                });
                if (ImgArray.length > 0) {
                    ImageResponse = ImgArray;
                };

                this.setState({
                    PageGridArr: cyclecountResponse,
                    totalCount: tc,
                    pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount),
                    CountedPageGridArr: [],
                    ImageAr: ImageResponse,
                    CountedImageAr: []
                });
            }
            else {
                /*[03/17/23, WW-630_01], Priyanka D */
                this.setState({ totalCount: "0", PageGridArr: [], CountedPageGridArr: [] });
            }
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }

    }
    CountedPageLoadData = (pageno) => {

        //$('#myTabContent').addClass('hide');
        //$('#mycountedTabContent').addClass('show');
        $('Counted-tab').prop('aria-selected', true)
        let CountedPageLoadBO = {
            EmployeeID: CookieService.getLocalStorageValues("Session_UserID"),
            PageNo: pageno,
            ItemCount: this.state.CounteditemCount,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"), /*[12/10/23, PC_CPW_119_02, Vishwa S]*/
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCAction.CountedPageLoad(CountedPageLoadBO);

    }
    loadFavPageResponse = () => {

        let favPageResponse = JSON.parse(CycleCountStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true,//isFirstTimeLoaded
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    updateFavPageResponse = () => {
        let a = CycleCountStore.updateFavPageResponse;
        if (CycleCountStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(CycleCountStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(CycleCountStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Cycle Counting",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            CCAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            CCAction.deleteFavPage(deleteFavPageBO)
        }
    };
    CountedPageLoadDataResponse = () => {
     
        let cyclecountResponse = JSON.parse(CycleCountStore.CountedPageData);
        let ccaray = cyclecountResponse.Table;
        let ImageTab = cyclecountResponse.ImgTable;
        //cyclecountResponse.Table[0].TOTAL_COUNT > 0 ? cyclecountResponse.Table[0].TOTAL_COUNT : 0,
        if (ccaray.length > 0) {
            let tc = cyclecountResponse.Table[0].TOTAL_COUNT;
            let ImageResponse;
            cyclecountResponse = cyclecountResponse.Table.filter((v, i, a) => a.findIndex(t => (t.INV_ITEM_ID.trim().toUpperCase() === v.INV_ITEM_ID.trim().toUpperCase())) === i);
            if (ImageTab.length > 0) {
                ImageResponse = ImageTab;
            };

            this.setState({
                CountedPageGridArr: cyclecountResponse,
                CountedtotalCount: tc,
                CountedpageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.CounteditemCount),
                PendingOrCounted: "1",
                PageGridArr: [],
                ImageAr: [],
                CountedImageAr: ImageResponse
            });
        }
        else {
            /*[03/17/23, WW-630_02], Priyanka D */
            this.setState({ CountedtotalCount: "0", PendingOrCounted: "1", PageGridArr: [], CountedPageGridArr: [], CountedpageNo: 0 });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    UpdateQuantityResponse = (data) => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateQtyResponse = JSON.parse(CycleCountStore.ResponseData);
        let result = UpdateQtyResponse.Table1[0].lblDBErr1
        if (result == "Successfully Updated") {
            //5623 - update a index of accordian after updated a quantity [4/22/2025] Nachiappan
            this.setState({ sucpopItem: UpdateQtyResponse.Table1[0].ItemId, openAccordionIndex: null })
            $('#Success-alert').modal('show');
        }
        else {
            this.setState({ errorMessage: UpdateQtyResponse.Table1[0].lblDBErr1 })
            $('#Failure-alert').modal('show');
        }
    }
    DoneClick = () => {
        this.CCPageLoadData("1");
    }
    handlePageClick = (data) => {

        let pageNo = data.selected + 1;
        /*[03/17/23, WW-630_03], Priyanka D */
        //5623 - update a index of accordian after navigating to different page [4/22/2025] Nachiappan
        this.setState({ pageNo: pageNo, PageGridArr: [], openAccordionIndex: null });
        this.CCPageLoadData(pageNo);
    };
    //CPW-95 Vishwa S
    //handleCountedPageClick = (data) => {

    //    let pageNo = data.selected + 1;
    //    /*[03/17/23, WW-630_04], Priyanka D */
    //    this.setState({ CountedpageNo: pageNo, CountedPageGridArr: [] });
    //    this.CountedPageLoadData(pageNo);
    //};
    onquantityChange = (e, index) => {

        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            let { PageGridArr } = this.state;
            this.state.PageGridArr[index].EnteredQty = e.target.value
            this.setState({ PageGridArr: PageGridArr, qtyvalue: e.target.value })
        }
    };
    onAccordianClick = (event, index) => {

        //  $('tr').addClass('tr-sample');
        // $(`.tr-sample`).addClass('d-none');
        const { openAccordionIndex } = this.state;

        // Close the previously open accordion
        if (openAccordionIndex !== null && openAccordionIndex !== index) {
            $(`#contentrow-${openAccordionIndex}`).addClass('d-none');
            $(`#arrow-${openAccordionIndex}`).removeClass('accordion-arrow-change');
        }

        // Toggle the clicked accordion
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');

        // Update the state
        this.setState({ openAccordionIndex: openAccordionIndex === index ? null : index });

        // Remove border from all rows and add it to the clicked row
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');
    };
    UpdateClick = (Item) => {
        if (Item.EnteredQty != "" && Item.EnteredQty != " ") {
            if (this.state.firsttimecheck1.length == 0) {
                this.state.firsttimecheck1.push({
                    ItemId: Item.INV_ITEM_ID,
                    StorageArea: Item.STORAGE_AREA,
                    Stock_Level_1: Item.STOR_LEVEL_1,
                    Stock_Level_2: Item.STOR_LEVEL_2,
                    Stock_Level_3: Item.STOR_LEVEL_3,
                    Stock_Level_4: Item.STOR_LEVEL_4,
                });
                if (this.state.firsttimecheck1.length == 1 && this.state.firsttimecheck1[0].ItemId == Item.INV_ITEM_ID) {
                    if (this.state.qtyvalue != Item.QTY_SYSTEM_BASE) {
                        $('#Update-alert').modal('show');
                        this.setState({ firstcount: Item.EnteredQty });
                    }
                    //CPW-95 Vishwa S
                    else {
                        let values = this.state.firsttimecheck1;
                        values.forEach((val) => {
                            values.splice(val);
                        })
                        let UpdateQuantityBO = {
                            QTY: Item.EnteredQty,
                            StorageArea: Item.STORAGE_AREA,
                            ISA_FIRST_COUNT: parseInt(this.state.firstcount),
                            ItemID: Item.INV_ITEM_ID,
                            Stock_Level_1: Item.STOR_LEVEL_1,
                            Stock_Level_2: Item.STOR_LEVEL_2,
                            Stock_Level_3: Item.STOR_LEVEL_3,
                            Stock_Level_4: Item.STOR_LEVEL_4,
                            /*[15/12/23, PC_CPW_95_01, Vishwa S]*/
                            ISA_CRIB_IDENT: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
                            ISA_Counting_Event: Item.ISA_COUNTING_EVENT
                        }
                        this.setState({
                            firsttimecheck1: values, firstcount: 0, pageNo: 1 //CPW-95 Vishwa S
                        });
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        CCAction.CCUpdateQuantity(UpdateQuantityBO);
                    }
                }
            }
            else {
                if (this.state.firsttimecheck1[0].ItemId != Item.INV_ITEM_ID) {
                    let values = this.state.firsttimecheck1;
                    values.forEach((val) => {
                        values.splice(val);
                    });
                    this.setState({ firstcount: this.state.qtyvalue, firsttimecheck1: values });
                    this.state.firsttimecheck1.push({
                        ItemId: Item.INV_ITEM_ID,
                        StorageArea: Item.STORAGE_AREA,
                        Stock_Level_1: Item.STOR_LEVEL_1,
                        Stock_Level_2: Item.STOR_LEVEL_2,
                        Stock_Level_3: Item.STOR_LEVEL_3,
                        Stock_Level_4: Item.STOR_LEVEL_4,
                    });
                    if (this.state.firsttimecheck1.length == 1 && this.state.firsttimecheck1[0].ItemId == Item.INV_ITEM_ID) {
                        if (this.state.qtyvalue != Item.QTY_SYSTEM_BASE) {
                            $('#Update-alert').modal('show');
                            this.setState({ firstcount: this.state.qtyvalue });
                        }
                    }
                }
                else {
                    if (this.state.firsttimecheck1.length == 1 && this.state.firsttimecheck1[0].ItemId == Item.INV_ITEM_ID) {
                        let values = this.state.firsttimecheck1;
                        values.forEach((val) => {
                            values.splice(val);
                        })
                        let UpdateQuantityBO = {
                            QTY: Item.EnteredQty,
                            StorageArea: Item.STORAGE_AREA,
                            ISA_FIRST_COUNT: parseInt(this.state.firstcount),
                            ItemID: Item.INV_ITEM_ID,
                            Stock_Level_1: Item.STOR_LEVEL_1,
                            Stock_Level_2: Item.STOR_LEVEL_2,
                            Stock_Level_3: Item.STOR_LEVEL_3,
                            Stock_Level_4: Item.STOR_LEVEL_4,
                            /*[15/12/23, PC_CPW_95_01, Vishwa S]*/
                            ISA_CRIB_IDENT: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
                            ISA_Counting_Event: Item.ISA_COUNTING_EVENT
                        }
                        this.setState({
                            firsttimecheck1: values, firstcount: 0, pageNo: 1 //CPW-95 Vishwa S
                        });
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        CCAction.CCUpdateQuantity(UpdateQuantityBO);
                    }

                }
            }
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter quantity"
            });
        }
    }
    //CPW-95 - removed counted tab ,Vishwa S
    //bindcountedgriddata = () => {

    //    return this.state.CountedPageGridArr.map((order, index) => {

    //        let stor1 = order.STOR_LEVEL_1 == "-" ? " " : order.STOR_LEVEL_1;
    //        let stor2 = order.STOR_LEVEL_1 == "-" ? " " : order.STOR_LEVEL_2;
    //        let stor3 = order.STOR_LEVEL_1 == "-" ? " " : order.STOR_LEVEL_3;
    //        let stor4 = order.STOR_LEVEL_1 == "-" ? " " : order.STOR_LEVEL_4;
    //        let location = order.STORAGE_AREA + " " + stor1 + " " + stor2 + " " + stor3 + " " + stor4;
    //        let ImageUrl = "";
    //        if (this.state.CountedImageAr != "" && this.state.CountedImageAr!=null) {
    //            let ImageDet = this.state.CountedImageAr.filter((value, indexVal) => value.CUSTOMER_PART_NUMBER == order.INV_ITEM_ID);
    //            ImageUrl = ImageDet[0].ImageUrl;
    //        }
    //        //let orderLineItemCount = this.state.favOrderLineItemData.filter((value, indexVal) => value.ORDER_NO == order.ORDER_NO).length;
    //        return (<React.Fragment key={order.INV_ITEM_ID}>
    //            <tr>
    //                <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
    //                    <span className="accordion-arrow" id={`arrow-${index}`} />
    //                </td>
    //                <td>{order.INV_ITEM_ID}</td>
    //                <td>{order.DESCR60}</td>
    //                <td>{location}</td>
    //            </tr>
    //            <tr className="p d-none" id={`contentrow-${index}`}>
    //                <td colSpan="11" className="hiddenRow" id="order-row-1">
    //                    <div className="py-1" id={`order-row-${index}`}>

    //                        {/* {orderLineItemCount > 0 ?*/} <React.Fragment>

    //                            <div className="col-md-12 float-left mx-0 mb-3 pt-3 pb-2 item-box" key={index}>
    //                                <div class="">
    //                                    <div className="accordian-body collapse show" id="order-row-1" style={{}}>
    //                                        <div className="col-md-12 mx-0 item-box">
    //                                            <div className="row mx-0  item-box py-3">
    //                                                {ImageUrl != "" ? <div className="col-lg-1 col-md-2 pr-0">
    //                                                    <img src={ImageUrl} alt="Image" style={{ width: "134px" }} />
    //                                                </div> : <div className="col-lg-2 col-md-2 pr-0">
    //                                                        <img src="/Images/noimage_new.png" alt="No_Image" style={{ width: "134px" }} />
    //                                                    </div>}
    //                                                <div className="col-lg-11 col-md-9 pl-5"> {/*[12/10/23, PC_CPW_119_29, Vishwa S]*/}
    //                                                    <div className="row mx-0">
    //                                                        <div className="col-md-12">
    //                                                            <span className="fav-item-title"><span className="float-left mt-2 mb-2">{order.INV_ITEM_ID}</span>
    //                                                            </span>
    //                                                        </div>
    //                                                        <label className="col-md-12 catalog-label content-width">{order.DESCRSHORT}</label>
    //                                                        <label className="col-md-12 item-details-value content-width">{order.DESCR60}</label>
    //                                                        <div className="col-md-12">
    //                                                            <div className="row">
    //                                                                <div className="col-md-3 mr-2">
    //                                                                    <label className="catalog-label mt-2 mr-1 float-none"><Trans>Last Updated On</Trans><span> :</span> </label>
    //                                                                    <label className="item-details-value mt-2 float-none">{order.LASTUPDDTTM}</label>
    //                                                                </div>
    //                                                                <div className="col-md-3">
    //                                                                    <label className="catalog-label mt-2 mr-1 float-none"><Trans>Bin</Trans><span> </span><Trans>Location</Trans><span> :</span> </label>
    //                                                                    <label className="item-details-value mt-2 float-none">{location}</label>
    //                                                                </div>
    //                                                                <div className="col-md-1">
    //                                                                    <label className="catalog-label mt-2 mr-1 float-none">UOM : </label>
    //                                                                    <label className="item-details-value mt-2 float-none">{order.UNIT_OF_MEASURE}</label>
    //                                                                </div>
    //                                                                <div className="col-md-4">
    //                                                                    <span className="float-left catalog-label mt-2  mr-2"><Trans>Entered Item Count</Trans><span> :</span> </span>
    //                                                                    <label className="item-details-value mt-2 float-none">{order.QTY_COUNT}</label>
    //                                                                    {/* <input type="text" defaultValue={2} className="form-control  float-left catalog-inline-qty" name="itemQuantity" id={`itemQuantity${childindex + 1}`} onChange={(e) => this.onquantityChange(e, index)} />*/}
    //                                                                </div>
    //                                                                {/* //<div className="col-md-1">
    //                                            //    <button className="btn btn-primary custom-btn-primary primary-btn float-right px-5" data-toggle="modal" data-target="#submit" onClick={() => this.UpdateClick()}>Update</button>
    //                                            //</div>*/}
    //                                                            </div>
    //                                                        </div>
    //                                                    </div>
    //                                                </div>
    //                                            </div>
    //                                        </div>
    //                                    </div>
    //                                </div></div>
    //                        </React.Fragment>{/* : `No line items are present in this order`}*/}
    //                    </div>
    //                </td>
    //            </tr>
    //        </React.Fragment>);
    //    })
    //}

    bindgriddata = () => {

        return this.state.PageGridArr.map((order, index) => {

            let stor1 = order.STOR_LEVEL_1 == "-" ? "" : order.STOR_LEVEL_1
            let stor2 = order.STOR_LEVEL_1 == "-" ? "" : order.STOR_LEVEL_2
            let stor3 = order.STOR_LEVEL_1 == "-" ? "" : order.STOR_LEVEL_3
            let stor4 = order.STOR_LEVEL_1 == "-" ? "" : order.STOR_LEVEL_4
            let location = order.STORAGE_AREA + " " + stor1 + " " + stor2 + " " + stor3 + " " + stor4;
            let ImageUrl = "";
            if (this.state.ImageAr != "" && this.state.ImageAr != null) {
                let ImageDet = this.state.ImageAr.filter((value, indexVal) => value.CUSTOMER_PART_NUMBER == order.INV_ITEM_ID);
                /*CPW-95 Vishwa S*/
                if (ImageDet[0] != undefined) {
                    ImageUrl = ImageDet[0].ImageUrl;
                    if (ImageUrl != "\N" && ImageUrl != "\\N") {
                        let urlsArray = ImageUrl.split('|');
                        ImageUrl = urlsArray[0]
                    }
                }
            }
            return (<React.Fragment key={order.INV_ITEM_ID + index}>
                <tr>
                    <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>
                        <span className={`accordion-arrow ${this.state.openAccordionIndex === index ? 'accordion-arrow-change' : ''}`} id={`arrow-${index}`} />
                    </td>
                    <td>{order.INV_ITEM_ID}</td>
                    <td>{order.DESCR60}</td>
                    <td>{location}</td>
                </tr>
                <tr className={`p ${this.state.openAccordionIndex === index ? '' : 'd-none'} tr-sample`} id={`contentrow-${index}`}>
                    <td colSpan="11" className="hiddenRow" id="order-row-1">
                        <div className="py-1" id={`order-row-${index}`}>
                            <React.Fragment>
                                <div className="col-md-12 float-left mx-0 mb-3 pt-3 pb-2 item-box" key={index}>
                                    <div className="">
                                        <div className="accordian-body collapse show" id="order-row-1" style={{}}>
                                            <div className="col-md-12 mx-0 item-box">
                                                <div className="row mx-0  item-box py-3">
                                                    {ImageUrl != "" && ImageUrl != "\N" && ImageUrl != "\\N" ?
                                                        <div className="col-lg-1 col-md-2 pr-0">
                                                            <img src={ImageUrl} alt="Image" style={{ width: "134px" }} />
                                                        </div> :
                                                        <div className="col-lg-1 col-md-2 pr-0">
                                                            <img src="/Images/noimage_new.png" alt="No_Image" style={{ width: "134px" }} />
                                                        </div>
                                                    }
                                                    <div className="col-lg-11 col-md-9 pl-5">
                                                        <div className="row mx-0">
                                                            <div className="col-md-12">
                                                                <span className="fav-item-title">
                                                                    <span className="float-left mt-2 mb-2">{order.INV_ITEM_ID}</span>
                                                                </span>
                                                            </div>
                                                            <label className="col-md-12 catalog-label content-width">{order.DESCRSHORT}</label>
                                                            <label className="col-md-12 item-details-value content-width">{order.DESCR60}</label>
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-lg-3 col-md-12">
                                                                        <label className="catalog-label mt-2 float-none"><Trans>Last Updated On</Trans><span> :</span> </label>
                                                                        <label className="item-details-value mt-2 float-none">{order.LASTUPDDTTM}</label>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-12">
                                                                        <label className="catalog-label mt-2 float-none"><Trans>Location</Trans><span> :</span> </label>
                                                                        <label className="item-details-value mt-2 float-none">{location}</label>
                                                                    </div>
                                                                    <div className="col-lg-1 col-md-12">
                                                                        <label className="catalog-label mt-2 float-none">UOM : </label>
                                                                        <label className="item-details-value mt-2 float-none">{order.UNIT_OF_MEASURE}</label>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-12 mb-3 mb-lg-0">
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="float-left font-14 font-medium mt-1  mr-2"><Trans>Entered Item Count</Trans><span> :</span> </span>
                                                                            <input type="text" className="form-control  float-left catalog-inline-qty" name="itemQuantity" maxLength="10" id={`itemQuantity${index + 1}`} value={order.EnteredQty} onChange={(e) => this.onquantityChange(e, index)} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-2 col-md-12">
                                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-5" data-toggle="modal" data-target="#submit" onClick={() => this.UpdateClick(order)}><Trans>Update</Trans></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>{/* : `No line items are present in this order`}*/}
                        </div>
                    </td>
                </tr>
            </React.Fragment>
            );
        });
    };


    render() {
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid content-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading my-3">
                        <h5 className="page-title"><Trans>Cycle Count</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Notify" className="checknow" data-toggle="modal" data-target="#Note-confirmation" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Notify">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>

                    <div className="col-md-12">
                        {/* CPW-95 - removed counted tab ,Vishwa S <ul className="nav nav-tabs catalog-tabs-mobile catalog-tabs mt-4" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="Pending-tab" data-toggle="tab" href="#Pending" role="tab" aria-controls="Pending" aria-selected="true" onClick={(e) => this.CCPageLoadData("1")}><Trans>Pending</Trans></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Counted-tab" data-toggle="tab" href="#Counted" role="tab" aria-controls="Counted" aria-selected="false" onClick={(e) => this.CountedPageLoadData("1")}><Trans>Counted</Trans></a>
                            </li>
                        </ul>*/}
                        {this.state.PendingOrCounted == "0" ? <div className="tab-content Catalog-Items" id="myTabContent">
                            <div className="tab-pane fade active show" id="Pending" role="tabpanel" aria-labelledby="Pending-tab">
                                <div className="table-responsive table-customstyle-whitespace mt-3">
                                    <table className="table ZEUS_Grid FOM-grid WOA-grid">
                                        <thead>
                                            <tr>
                                                <th />
                                                <th className="position-sort-icon"><Trans>Item</Trans><span> #</span></th>
                                                <th className="position-sort-icon"><Trans>Description</Trans></th>
                                                <th className="position-sort-icon"><Trans>Location</Trans></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.PageGridArr.length > 0 ? this.bindgriddata() : (

                                                <tr>
                                                    <td colSpan="11">
                                                        <section className="site-undercontruction container text-center center-panel pt-4">
                                                            <div className="img-section">
                                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                                            </div>
                                                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                                            </p>
                                                        </section>
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                    {this.state.totalCount > 0 ?
                                        <div className="col-md-12 ">
                                            <span className="total-records mt-2 d-inline-block">
                                                <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                            </span>
                                            {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                                previousLabel={<span className="right-pagination-arrow" />}
                                                nextLabel={<span className="left-pagination-arrow" />}
                                                previousClassName={'page-item'}
                                                nextClassName={'page-item'}
                                                previousLinkClassName={'page-link'}
                                                nextLinkClassName={'page-link'}
                                                disabledClassName={'disabled'}
                                                breakLabel={'...'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                pageCount={this.state.pageCount}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={this.handlePageClick}
                                                containerClassName={'custom-pagination pagination float-right'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                hrefBuilder={() => '#'}
                                                forcePage={this.state.pageNo - 1}
                                            /> : null}

                                        </div> : null}
                                </div>
                            </div>
                        </div> :
                            /* CPW-95 - removed counted tab ,Vishwa S <div className="tab-content catalog-tab-content Catalog-Items" id="mycountedTabContent">
                                <div className="tab-pane p-3 fade active show" id="Counted" role="tabpanel" aria-labelledby="Counted-tab">
                                    <div className="table-responsive table-customstyle-whitespace mt-3">
                                        <table className="table ZEUS_Grid FOM-grid WOA-grid">
                                            <thead>
                                                <tr>
                                                    <th />
                                                    <th className="position-sort-icon"><Trans>Item</Trans><span> #</span></th>
                                                    <th className="position-sort-icon"><Trans>Description</Trans></th>
                                                    <th className="position-sort-icon"><Trans>Location</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.CountedPageGridArr.length > 0 ? this.bindcountedgriddata() : (

                                                    <tr>
                                                        <td colSpan="11">
                                                            <section className="site-undercontruction container text-center center-panel pt-4">
                                                                <div className="img-section">
                                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                                </div>
                                                                <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                                                </p>
                                                            </section>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </table>
                                        {this.state.CountedtotalCount > 0 ?
                                            <div className="col-md-12 ">
                                                <span className="total-records mt-2 d-inline-block">
                                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.CountedtotalCount}</span>
                                                </span>
                                                {this.state.CountedtotalCount > this.state.CounteditemCount ? <ReactPaginate
                                                    previousLabel={<span className="right-pagination-arrow" />}
                                                    nextLabel={<span className="left-pagination-arrow" />}
                                                    previousClassName={'page-item'}
                                                    nextClassName={'page-item'}
                                                    previousLinkClassName={'page-link'}
                                                    nextLinkClassName={'page-link'}
                                                    disabledClassName={'disabled'}
                                                    breakLabel={'...'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    pageCount={this.state.CountedpageCount}
                                                    marginPagesDisplayed={1}
                                                    pageRangeDisplayed={2}
                                                    onPageChange={this.handleCountedPageClick}
                                                    containerClassName={'custom-pagination pagination float-right'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                    hrefBuilder={() => '#'}
                                                    forcePage={this.state.CountedpageNo - 1}
                                                /> : null}

                                            </div> : null}
                                    </div>
                                </div>
                            </div>*/null}
                    </div></div>
                <div className="modal" id="Update-alert">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>Quantity</Trans><span> </span><Trans>Mismatch</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal"><Trans>Ok</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="Success-alert" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />

                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-3">
                                        <span className="question-mark-icon success-alert-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Success</Trans><span>!</span></label>
                                        <label className="confirm-label d-block">{this.state.sucpopItem}</label>
                                        <label className="confirm-content d-block"><Trans>Item Has Been Updated Successfully</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.DoneClick()}><Trans>Done</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="Failure-alert" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <div className="text-center mt-2">
                                            <img src="Images/close.png" alt="Update Failed" />
                                        </div>
                                        <div className="text-center my-4">
                                            <span className="info-label">{this.state.errorMessage}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal">OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
export default withTranslation()(CycleCount);